import { Machine } from './../../Services/Object_Classes/Machine/Machine';
import { MachineDB_controller } from 'src/app/Services/DB_Controller/MachineDB_controller';
import { data } from 'jquery';
import { DateFormatService } from '../../Services/Utilities/date-format.service';
import { QtyInformationComponent } from './qty-information/qty-information.component';
import { AngularFirestore } from '@angular/fire/firestore';
import { PartsInfoComponent } from './parts-info/parts-info.component';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogConfig, MatDialogRef, MatPaginator, PageEvent, Sort } from '@angular/material';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Part } from '../../Services/Object_Classes/Part/Part';
import { PartDB_controller } from '../../Services/DB_Controller/PartDB_controller';
import { PartTracker, PurchaseOrder } from '../../Services/Object_Classes/PurchaseOrder/PurchaseOrder';
import { PODB_controller } from '../../Services/DB_Controller/PODB_controller';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { WeightingDB_controller } from '../../Services/DB_Controller/WeightingDB_controller';
import { Weighting, WeightPartList } from '../../Services/Object_Classes/Weighting/Weighting';
import { AngularFireStorage } from '@angular/fire/storage';
import { firestore } from 'firebase';
import { ExcelHelperService } from 'src/app/Services/Utilities/excel-helper.service';
import { QCInfoComponent } from './qcinfo/qcinfo.component';
import { AddQCComponent } from './add-qc/add-qc.component';
import { QCRejectionComponent } from './qc-rejection/qc-rejection.component';
import { ViewConfirmationComponent } from './view-confirmation/view-confirmation.component';
import { PDFDocument } from 'pdf-lib';
import { Download } from 'downloadjs';
import * as fs from 'fs';

@Component({
  selector: 'app-qc',
  templateUrl: './qc.component.html',
  styleUrls: ['./qc.component.css'],
})
export class QCComponent implements OnInit {
  poFlag = false;
  partNumFlag = false;
  accQtyFlag = false;
  rejQtyFlag = false;
  rejRemFlag = false;
  wDateFlag = false;
  myControl = new FormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;
  myControl1 = new FormControl();
  options1: string[] = ['-', 'sink mark', 'short moulding', 'colour out', 'dimension out', 'pin broken', 'warping',
                        'black dot', 'pin mark', 'moisture mark'];
  filteredOptions1: Observable<string[]>;
  currentPONo: string;
  currentPartNum: string;
  scanning: any = '';

  TotAccQty: number[] = [];
  TotRejQty: number[] = [];
  RejRemark: string[] = [];
  LastWeightDate: Date[] = [];
  POPartList: PartTracker[] = [];
  POList: PurchaseOrder[] = [];
  PartList: Part[] = [];
  podb_Controller = new PODB_controller(this.db);
  partdb_Controller = new PartDB_controller(this.db,this.storage,this.firestore);
  weighting_Controller = new WeightingDB_controller(this.db);
  machine_controller = new MachineDB_controller(this.db);
  logs= [];

  //Pagination record
  length = 0;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 50];
  pageIndex = 0;
  offset = this.pageSize * this.pageIndex;
  search: string;
  sortedu = {
    active: 'weightDate',
    direction: 'desc'
  };
  WeightingRecordList: Weighting[] = [];
  WeightingList: WeightPartList[] = [];
  CloneWeightingRecordList: Weighting[] = [];
  @ViewChild('topPaginator', { read: MatPaginator, static: false }) topPaginator: MatPaginator;
  @ViewChild('bottomPaginator', { read: MatPaginator, static: false }) bottomPaginator: MatPaginator;


  //Pagination from stock record
  stocklength = 0;
  stockpageSize = 10;
  stockpageSizeOptions: number[] = [10, 25, 50];
  stockpageIndex = 0;
  stockoffset = this.stockpageSize * this.stockpageIndex;
  stocksearch: string;
  stocksortedu = {
    active: '',
    direction: ''
  };
  stockWeightingRecordList: Weighting[] = [];
  stockCloneWeightingRecordList: Weighting[] = [];
  @ViewChild('stocktopPaginator', { read: MatPaginator, static: false }) stocktopPaginator: MatPaginator;
  @ViewChild('stockbottomPaginator', { read: MatPaginator, static: false }) stockbottomPaginator: MatPaginator;

  QClog = []
  Weightlog = []
  Shiplog = []
  machineInfo = []
  machineList:Machine[]= [];

  qcLength = 10;
  weightLength = 10;
  shipLength = 10;

  stockIn = 0;
  stockOut = 0;
  datePicker: Date
  FromPicker: Date

  monthDate: Date;
  firstDayMonth:Date;
  LastDayMonth:Date;

  previousStockIn = 0;
  previousStockOut = 0;

  isFetching = true;

  constructor(
    private db: AngularFireDatabase,
    private dialog: MatDialog,
    private excelHelper: ExcelHelperService,
    private spinner: NgxSpinnerService,
    private toast : ToastrService,
    private storage:AngularFireStorage,
    private firestore: AngularFirestore,
    private dateService: DateFormatService
  ) {
    this.monthDate= new Date();
    var totalDay = new Date(this.monthDate.getFullYear(), this.monthDate.getMonth() + 1, 0).getDate();
    const temp = new Date(this.monthDate.getFullYear(), this.monthDate.getMonth(), 1);
    this.firstDayMonth = new Date(temp);
    this.firstDayMonth.setHours(0)
    this.firstDayMonth.setMinutes(0)
    this.firstDayMonth.setSeconds(0)
    this.LastDayMonth = new Date(temp.setDate(temp.getDate()+totalDay-1));
    this.LastDayMonth.setHours(23)
    this.LastDayMonth.setMinutes(59)
    this.LastDayMonth.setSeconds(59)
  }

  async ngOnInit() {
    this.datePicker = new Date();
    this.FromPicker = new Date(new Date().setMonth(this.datePicker.getMonth()-1));

    setTimeout(() => {
      this.isFetching = false;
    }, 2000);
    this.setup();
    this.getQCLog();
    this.getWeightLog();
    this.getShipLog();
    this.getDashboard();
  }

  NoJob(schedules){
    return schedules.filter(s=>s.QCDone).length === 0?true:false;
  }
  
  getDashboard(){
    this.getLog()
    this.getPreviousMonthLog()
    this.getMachineLog();
  }

  refresh(){
    this.setup();
  }

  getMachineLog(){
    const fromdate = firestore.Timestamp.fromDate(this.firstDayMonth);
    const toDate = firestore.Timestamp.fromDate(this.LastDayMonth);
    this.firestore.collection('QualityCheckLog',
    ref => ref.where('Date','>=',fromdate)
            .where('Date','<=',toDate)).get().forEach(data => {
        data.forEach(e => {
        this.firestore.collection('QualityCheckLog').doc(e.id).
        collection('PO').get().forEach(poLog => {

          const logs = [];
          poLog.forEach(log => {

            let rej = []
            let rejQty = 0
            if(log.data()['Rejected Information']){
              rej = Object.values(log.data()['Rejected Information']);
            }
            rej.forEach(element => {
              rejQty += element;
            });
            const info ={
              date : new Date(log.data().Date),
              acceptyQty: log.data()['Accepted Quantity'],
              PO:  log.data().PO_ID,
              Part: log.data().Part_ID,
              rejQty: rejQty,
            }
            logs.push(info);
          });

          logs.forEach(async e=>{
            // var snapshot = await this.db.database.ref('Purchase Order/'+e.PO + '/Part List').once('value');
            // if(snapshot.exists()){
            //   snapshot.forEach(childsnapshot=>{
            //     if(childsnapshot.child('Part No').val() === e.Part){
            //       if(childsnapshot.child('MachineNo').val()){
            //         const ind = this.machineList.findIndex(m=>childsnapshot.child('MachineNo').val().includes(m));

            //         if(ind !== -1){
            //           this.machineInfo[ind].acceptyQty += e.acceptyQty;
            //           this.machineInfo[ind].rejQty += e.rejQty;
            //         }
            //       }
            //     }
            //   })
            // }
          })
        });
      });
    });
  }
  
  getLog(){
    this.stockIn= 0;
    this.stockOut= 0;
    const fromdate = firestore.Timestamp.fromDate(this.firstDayMonth);
    const toDate = firestore.Timestamp.fromDate(this.LastDayMonth);
    this.firestore.collection('WeightingLog',
    ref => ref.where('Date','>=',fromdate)
    .where('Date','<=',toDate)
    ).get().forEach(data => {
      data.forEach(e => {
        const d = new Date(e.data().Date)
        const currentD = new Date();
        let flag =( d.getFullYear() === currentD.getFullYear()) &&( d.getMonth() === currentD.getMonth()) &&( d.getDate() === currentD.getDate())
        if(e.data().totalStockIn && !flag){
          this.stockIn += e.data().totalStockIn
          this.stockOut += e.data().totalStockOut
        }else{
          this.firestore.collection('WeightingLog').doc(e.id).
          collection('PO').get().forEach(poLog => {
            var totalStockIn = 0;
            var totalStockOut = 0;
            poLog.forEach(log => {
              if(log.data()['MadeToOrder'] || log.data()['MakeToStock']){
                if(parseFloat(log.data()['MadeToOrder']) !== 0){
                  this.stockOut += parseFloat(log.data()['MadeToOrder'])
                  totalStockOut += parseFloat(log.data()['MadeToOrder'])
                }else {
                  this.stockIn += parseFloat(log.data()['MakeToStock'])
                  totalStockIn += parseFloat(log.data()['MakeToStock'])
                }
              }
            });
            const updateInfo = {
              totalStockIn,
              totalStockOut
            }
            this.firestore.collection('WeightingLog').doc(e.id).update(updateInfo);
          });
        }
      });
    });
  }

  getPreviousMonthLog(){
    this.previousStockIn= 0;
    this.previousStockOut= 0;
    const first = new Date(this.firstDayMonth);
    const last = new Date(this.LastDayMonth);
    first.setMonth(first.getMonth()-1)
    last.setMonth(last.getMonth()-1)

    const fromdate = firestore.Timestamp.fromDate(first);
    const toDate = firestore.Timestamp.fromDate(last);
    this.firestore.collection('WeightingLog',
    ref => ref.where('Date','>=',fromdate)
    .where('Date','<=',toDate)
    ).get().forEach(data => {
      data.forEach(e => {
        if(e.data().totalStockIn){
          this.previousStockIn += e.data().totalStockIn
          this.previousStockOut += e.data().totalStockOut
        }else{
          this.firestore.collection('WeightingLog').doc(e.id).
          collection('PO').get().forEach(poLog => {
            var totalStockIn = 0;
            var totalStockOut = 0;
            poLog.forEach(log => {
              if(log.data()['MadeToOrder'] || log.data()['MakeToStock']){
                if(parseFloat(log.data()['MadeToOrder']) !== 0){
                  this.previousStockOut += parseFloat(log.data()['MadeToOrder'])
                  totalStockOut += parseFloat(log.data()['MadeToOrder'])
                }else {
                  this.previousStockIn += parseFloat(log.data()['MakeToStock'])
                  totalStockIn += parseFloat(log.data()['MakeToStock'])
                }
              }
            });
            const updateInfo = {
              totalStockIn,
              totalStockOut
            }
            this.firestore.collection('WeightingLog').doc(e.id).update(updateInfo);
          });
        }

      });
    });
  }

  searchLog(){
    this.getQCLog();
    this.getWeightLog();
    this.getShipLog();
  }

  getWeightLog(){
    this.Weightlog = [];
    const from = new Date(this.FromPicker);
    from.setHours(0)
    from.setMinutes(0)
    from.setSeconds(0)
    const to = new Date(this.datePicker);
    to.setHours(23)
    to.setMinutes(59)
    to.setSeconds(59)
    const fromdate = firestore.Timestamp.fromDate(from);
    const toDate = firestore.Timestamp.fromDate(to);
    this.firestore.collection('WeightingLog',
    ref => ref.where('Date','>=',fromdate)
            .where('Date','<=',toDate)
            .orderBy('Date', 'desc').limit(10)).get().forEach(data => {
      data.forEach(e => {

        if(this.Weightlog.length > this.weightLength){
          return;
        }
        this.firestore.collection('WeightingLog').doc(e.id).
        collection('PO', ref => ref.orderBy('Date', 'desc').limit(10)).get().forEach(poLog => {
          poLog.forEach(log => {
            if(this.Weightlog.length > this.weightLength){
              return;
            }

            const madeToOrder = parseFloat(log.data()["MadeToOrder"])!==0?true:false;

            const info ={
              date : new Date(log.data().Date),
              packQty: madeToOrder?log.data()['MadeToOrder']:log.data()['MakeToStock'],
              PO:  log.data().PO_ID,
              Part: log.data().Part_ID,
              status: madeToOrder?"Made To Order":"Made To Stock",
              RackingNo: log.data().RackingNo,
              WarehouseLocation: log.data().WarehouseLocation,
            }

            this.Weightlog.push(info);
          });
        });
      });
    });
  }

  getQCLog(){
    this.QClog = [];
    const from = new Date(this.FromPicker);
    from.setHours(0)
    from.setMinutes(0)
    from.setSeconds(0)
    const to = new Date(this.datePicker);
    to.setHours(23)
    to.setMinutes(59)
    to.setSeconds(59)
    const fromdate = firestore.Timestamp.fromDate(from);
    const toDate = firestore.Timestamp.fromDate(to);
    this.firestore.collection('QualityCheckLog',
    ref => ref.where('Date','>=',fromdate)
            .where('Date','<=',toDate)
            .orderBy('Date', 'desc').limit(10)).get().forEach(data => {
        data.forEach(e => {
        if(this.QClog.length > this.qcLength){
          return;
        }
        this.firestore.collection('QualityCheckLog').doc(e.id).
        collection('PO', ref => ref.orderBy('Date', 'desc').limit(10)).get().forEach(poLog => {
          poLog.forEach(log => {
            if(this.QClog.length > this.qcLength){
              return;
            }
            let rej = []
            let rejQty = 0
            if(log.data()['Rejected Information']){
              rej = Object.values(log.data()['Rejected Information']);
            }
            rej.forEach(element => {
              rejQty += element;
            });
            const info ={
              date : new Date(log.data().Date),
              acceptyQty: log.data()['Accepted Quantity'],
              PO:  log.data().PO_ID,
              Part: log.data().Part_ID,
              rejQty: rejQty,
            }
            this.QClog.push(info);
          });
        });
      });
    });
  }

  getShipLog(){
    this.Shiplog = [];
    const from = new Date(this.FromPicker);
    from.setHours(0)
    from.setMinutes(0)
    from.setSeconds(0)
    const to = new Date(this.datePicker);
    to.setHours(23)
    to.setMinutes(59)
    to.setSeconds(59)
    const fromdate = firestore.Timestamp.fromDate(from);
    const toDate = firestore.Timestamp.fromDate(to);

    this.firestore.collection('ShippingLog',
    ref => ref.where('Date','>=',fromdate)
            .where('Date','<=',toDate)
            .orderBy('Date', 'desc').limit(10)).get().forEach(data => {
      data.forEach(e => {
        if(this.Shiplog.length > this.shipLength){
          return;
        }
        this.firestore.collection('ShippingLog').doc(e.id).
        collection('PO', ref => ref.orderBy('Date', 'desc').limit(10)).get().forEach(poLog => {
          poLog.forEach(log => {
            if(this.Shiplog.length > this.shipLength){
              return;
            }

            const info ={
              date : new Date(log.data().Date),
              qty:log.data()['Part Qty'],
              PO:  log.data().PO_ID,
              Part: log.data()['Part Number'],
              updatedBy:log.data().UpdateBy
            }

            this.Shiplog.push(info);
          });
        });
      });
    });
  }

  setup(){
    this.spinner.show();
    this.weighting_Controller.getWeightingList().then(data => {
      //this.getPartInfoByWeighting(data);
      this.WeightingRecordList =  data;
      this.CloneWeightingRecordList = this.WeightingRecordList.slice();
      this.length = this.WeightingRecordList.length;
      this.sortRecordList();
      this.limitList();
      this.spinner.hide();
    });

    this.weighting_Controller.getIncompleteWeightingList().then(data => {
      //this.getPartInfo(data);
      this.WeightingList = data;
      this.WeightingList.sort((a,b)=>{
        return new Date(a.Due_Date).getTime() < new Date(b.Due_Date).getTime()? -1 : new Date(a.Due_Date).getTime() > new Date(b.Due_Date).getTime() ? 1 :0
      });

      this.spinner.hide();
    });
  }

  viewDetail(PO){
    const dialogRefupdatePart = this.dialog.open(AddQCComponent, {
      data: PO,
      width: '80%',
      height: '80%',
      autoFocus: false
    });

    dialogRefupdatePart.afterClosed().subscribe(result => {
      this.setup();
    });
  }

  DynamicSearchRecord(RecordName: string): void {
    this.search = RecordName;
    this.CloneWeightingRecordList = this.WeightingRecordList.filter(u => {
      const flag = String(u.PO_No).toLowerCase().includes(this.search.toLowerCase())

      for (const part of u.Weight_Part_List) {
        if (part.Part_No.toLowerCase().includes(this.search.toLowerCase()) || (part.UpdateBy.toLowerCase().includes(this.search.toLowerCase())))
          return true;
      }
      return flag

    });
    this.length = this.CloneWeightingRecordList.length;
    this.sortRecordList();
    this.limitList();
    this.topPaginator.firstPage();
    this.bottomPaginator.firstPage();

  }

  DS() {
    this.CloneWeightingRecordList = this.WeightingRecordList.filter(u => {
      const flag = String(u.PO_No).toLowerCase().includes(this.search.toLowerCase())

      for (const part of u.Weight_Part_List) {
        if (part.Part_No.toLowerCase().includes(this.search.toLowerCase()) || (part.UpdateBy.toLowerCase().includes(this.search.toLowerCase())))
          return true;
      }
      return flag

    });
    this.length = this.CloneWeightingRecordList.length;
  }

  paginator(pageEvent: PageEvent) {
    this.pageSize = pageEvent.pageSize;
    this.pageIndex = pageEvent.pageIndex;
    this.offset = this.pageSize * this.pageIndex;
    if (this.topPaginator.pageIndex < this.pageIndex) {
      this.topPaginator.nextPage();
    } else if (this.topPaginator.pageIndex > this.pageIndex) {
      this.topPaginator.previousPage();
    }
    if (this.bottomPaginator.pageIndex < this.pageIndex) {
      this.bottomPaginator.nextPage();
    } else if (this.bottomPaginator.pageIndex > this.pageIndex) {
      this.bottomPaginator.previousPage();
    }
    if (this.search) {
      this.DS();
    } else {
      this.CloneWeightingRecordList = this.WeightingRecordList.slice();
    }
    this.sortRecordList();
    this.limitList();
  }

  limitList() {
    this.CloneWeightingRecordList = this.CloneWeightingRecordList.slice(this.offset, (this.offset + this.pageSize));
  }

  sortRecordList() {
    if (!this.sortedu.active || this.sortedu.direction === '') {
      return;
    }
    this.CloneWeightingRecordList = this.CloneWeightingRecordList.sort((a, b) => {
      const isAsc = this.sortedu.direction === 'asc';
      switch (this.sortedu.active) {
        case 'poNo': return this.compare(a.PO_No, b.PO_No, isAsc);
        case 'partNo': return this.compare(a.Weight_Part_List[0].Part_No, b.Weight_Part_List[0].Part_No, isAsc);
        case 'acceptedQty': return this.compare(a.Weight_Part_List[0].Accept_Qty, b.Weight_Part_List[0].Accept_Qty, isAsc);
        case 'rejectedQty': return this.compare(a.Weight_Part_List[0].Reject_Qty, b.Weight_Part_List[0].Reject_Qty, isAsc);
        case 'working': return this.compare(a.Weight_Part_List[0].WorkingArea, b.Weight_Part_List[0].WorkingArea, isAsc);
        case 'updateBy': return this.compare(a.Weight_Part_List[0].UpdateBy, b.Weight_Part_List[0].UpdateBy, isAsc);
        case 'qcDate': return this.compareDate(a.Weight_Part_List[0].Weight_Date, b.Weight_Part_List[0].Weight_Date, isAsc);
        case 'weightDate': return this.compareDate(a.Weight_Part_List[0].WeightingInfo.Updated_Date, b.Weight_Part_List[0].WeightingInfo.Updated_Date, isAsc);
        default: return 0;
      }
    });
  }

  sortData(sort: Sort) {
    this.sortedu = sort;
    this.CloneWeightingRecordList = this.WeightingRecordList.slice();
    if (this.search) {
      this.DS();
    }
    if (!sort.active || sort.direction === '' && !this.search) {
      this.CloneWeightingRecordList = this.WeightingRecordList.slice();
      this.limitList();
      return;
    }

    this.CloneWeightingRecordList = this.CloneWeightingRecordList.sort((a, b) => {
      const isAsc = this.sortedu.direction === 'asc';
      switch (this.sortedu.active) {
        case 'poNo': return this.compare(a.PO_No, b.PO_No, isAsc);
        case 'partNo': return this.compare(a.Weight_Part_List[0].Part_No, b.Weight_Part_List[0].Part_No, isAsc);
        case 'acceptedQty': return this.compare(a.Weight_Part_List[0].Accept_Qty, b.Weight_Part_List[0].Accept_Qty, isAsc);
        case 'rejectedQty': return this.compare(a.Weight_Part_List[0].Reject_Qty, b.Weight_Part_List[0].Reject_Qty, isAsc);
        case 'working': return this.compare(a.Weight_Part_List[0].UpdateBy, b.Weight_Part_List[0].UpdateBy, isAsc);
        case 'updateBy': return this.compare(a.Weight_Part_List[0].WorkingArea, b.Weight_Part_List[0].WorkingArea, isAsc);
        case 'qcDate': return this.compareDate(a.Weight_Part_List[0].Weight_Date, b.Weight_Part_List[0].Weight_Date, isAsc);
        case 'weightDate': return this.compareDate(a.Weight_Part_List[0].WeightingInfo.Updated_Date, b.Weight_Part_List[0].WeightingInfo.Updated_Date, isAsc);

        default: return 0;
      }
    });
    this.limitList();
  }

  compare(a: number | string , b: number | string , isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  compareDate(a, b, isAsc: boolean) {
    a = new Date(a);
    b = new Date(b);
    return (a > b ? -1 : a < b ? 1 : 0) * (isAsc ? -1 : 1);
  }

  viewParts(record){
    this.dialog.open(PartsInfoComponent, {
      width: '80%',
      height: '80%',
      data: record
    });
  }

  GetActivity(value){
    this.qcLength = value;
    this.getQCLog();
  }

  GetActivity2(value){
    this.weightLength = value;
    this.getWeightLog();
  }

  GetActivity3(value){
    this.shipLength = value;
    this.getShipLog();
  }

  detectChanges(event) {
    this.monthDate = event;
    var totalDay = new Date(this.monthDate.getFullYear(), this.monthDate.getMonth() + 1, 0).getDate();
    const temp = new Date(this.monthDate.getFullYear(), this.monthDate.getMonth(), 1);
    this.firstDayMonth = new Date(temp);
    this.firstDayMonth.setHours(0)
    this.firstDayMonth.setMinutes(0)
    this.firstDayMonth.setSeconds(0)
    this.LastDayMonth = new Date(temp.setDate(temp.getDate()+totalDay-1));
    this.LastDayMonth.setHours(23)
    this.LastDayMonth.setMinutes(59)
    this.LastDayMonth.setSeconds(59)
    this.getDashboard();
  }

  Nan(value) {
    if (isNaN(value))
      return 0
    else
      return value
  }

  exportToExcel() {
    const exportInformation = [];
    this.spinner.show();
    const weight = this.WeightingRecordList.sort((a,b)=>{
      return (a.PO_No < b.PO_No ? -1 : 1)* (true ? 1 : -1);
    }
      );
    for (const w of weight) {
      for (const part of w.Weight_Part_List) {
        const info ={
          "PO Number":w.PO_No || "-",
          "Part Number": part.Part_No || "-",
          "Accepted Quantity":part.Accept_Qty || 0,
          "Made to Order": part.WeightingInfo? part.WeightingInfo.MadeToOrder: "Not Weighting Yet",
          "Make to Stock": part.WeightingInfo? part.WeightingInfo.MakeToStock: "Not Weighting Yet",
          "Rejected Quantity":part.Reject_Qty || 0,
          "Rejected Reason":part.RejectedInfos.map(v=>v.Code).join(' ,'),
          "Working Area":part.WorkingArea || "",
          "Updated By":part.UpdateBy || "-",
          "QC Date":part.Weight_Date|| "-",
        }
        exportInformation.push(info)
      }
    }
    this.excelHelper.exportAsExcelFile(exportInformation, 'QC'+new Date().getTime());
    this.spinner.hide();
  }

  view(part, statement) {
    var info;
    switch (statement) {
      case 'accept':
        info = {
          title: 'Information',
          data: [{
            'label': 'Made To Order',
            'value': part.MadeToOrder,
            'size': 'col-lg-12'
          },
          {
            'label': 'Make To Stcck',
            'value': part.MakeToStock,
            'size': 'col-lg-12'
          },
          ]
        }
        break;
        case 'reject':
        info = {
          title: 'Information',
          data: [],
        }
        for (const rejectInfo of part) {
          let i = {
            'label': rejectInfo.Code,
            'value': rejectInfo.Quantity,
            'size': 'col-lg-12'
          }
          info.data.push(i);
        }
        break;
    }
    this.dialog.open(QtyInformationComponent, {
      width: '50%',
      height: 'auto',
      data: info
    });

  }

  viewAll(machine: Machine){
    this.dialog.open(QCInfoComponent, {
      width: '80%',
      height: '80%',
      data: {
        title: machine.Machine_No + " All Completed PO",
        tableData: machine.Schedule_Track.filter(e=>e.QCDone)
      }
    });
  }

  viewAllNotYet(machine: Machine){
    this.dialog.open(QCInfoComponent, {
      width: '80%',
      height: '80%',
      data: {
        title: machine.Machine_No + " All Pending PO",
        tableData: machine.Schedule_Track.filter(e=>!e.QCDone)
      }
    });
  }

  getColorPanel(po:WeightPartList){
    if(po.Status == 'Incomplete'){
      let flag = true;

      if(po.Due_Date.getTime() - new Date().getTime() <= 259200000){
        flag = false;
        //$('#SO' + index).addClass('error');
        return 'error';
      }
      else if(po.Due_Date.getTime() - new Date().getTime() <= 604800000){
        flag = false;
        //$('#SO' + index).addClass('warning');
        return 'warning';
      }
      else{
        //$('#SO' + index).addClass('running');
        return 'running';
      }
    }
  }

  async print(record: WeightPartList, record2: string){
    const uint8Array = fs.readFileSync('../../../../assets/Inspection.pdf');
    const pdfDoc = await PDFDocument.load(uint8Array);
    const form = pdfDoc.getForm();

    const upperDate = form.getTextField('Upper_Date');
    const customer = form.getTextField('Customer');
    const po = form.getTextField('PO');
    const drawing = form.getTextField('Drawing');
    const partDescription = form.getTextField('Part Description');
    const partNumber = form.getTextField('Part Number');
    const rev = form.getTextField('Rev');
    const inspectedBy = form.getTextField('Inspected By');
    const qtyInspected = form.getTextField('Qty Inspected');
    const lotSize = form.getTextField('Lot Size');

    // Fill in the basic info fields
    upperDate.setText(this.dateService.convertDateIntoDayMonthYear(new Date()));
    customer.setText(record.customerName);
    po.setText(record2);
    drawing.setText(record.Part_No);
    partDescription.setText(record.Part_Name);
    partNumber.setText(record.Part_No);
    rev.setText(record.rev);
    inspectedBy.setText(record.InspectedBy);
    qtyInspected.setText(record.Inspect_Qty.toString());
    lotSize.setText('-');

    const pdfBytes = await pdfDoc.save()

    // Trigger the browser to download the PDF document
    Download(pdfBytes, "test.pdf", "application/pdf");
  }

  viewDrawing(record: any, record2: string){
    const addPOModel = {
      inspectType : record.InspectionType,
      customerName : record.customerName,
      soNumber : record2,
      drawingNo : record.Part_No,
      partName : record.Part_Name,
      partNo : record.Part_No,
      rev : record.rev,
      inspectBy : record.InspectedBy,
      quantity : record.PO_Qty,
      lotSize : record.Inspect_Qty,
      joNumber : record.JO_No,
      parts: []
    };

    record.PointList.forEach((element, index) => {
      const info = {
        unit: element.Unit,
        standard: element.Standard,
        tolerence: element.Tolerance,
        tool: element.Tool,
        samples: []
      };

      element.SampleList.forEach((element) => {
        const info2 = {
          reading: element.Reading
        };

        info.samples.push(info2);
      });

      addPOModel.parts.push(info);
    });

    const dialogRefupdatePart = this.dialog.open(ViewConfirmationComponent, {
      data: addPOModel,
      width: '80%',
      height: '80%',
      autoFocus: false
    });

    dialogRefupdatePart.afterClosed().subscribe(result => {
      this.setup();
    });
  }


  ScanOutsource(){
    $('#barcode').val('');
    $('#barcode').trigger('focus');
    this.scanning = "Scanning.......";
  }

  async barcode(event){
    let PO = await this.WeightingList.find(a=>a.JO_No == event.target.value);
    
    const dialogRefupdatePart = this.dialog.open(AddQCComponent, {
      data: PO,
      width: '80%',
      height: '80%',
      autoFocus: false
    });

    dialogRefupdatePart.afterClosed().subscribe(result => {
      $('#barcode').val('');
      $('#barcode').trigger('focus');
      this.setup();
    });
  }

  async getPartInfo(pt: WeightPartList[]): Promise<void> {
    pt.forEach(async data =>{
        var snapshot = await this.db.database.ref('Part').child(data.Part_No).once('value');
        if (snapshot.exists()) {
          data.Part_No = snapshot.child('Part No').val();
        }
    });
  }

  async getPartInfoByWeighting(pt: Weighting[]): Promise<void> {
    pt.forEach(data => {
      data.Weight_Part_List.forEach(async (pl) => {
        var snapshot = await this.db.database.ref('Part').child(pl.Part_No).once('value');
        if ( snapshot.exists()) {
          pl.Part_No = snapshot.child('Part No').val();
        }
      });
    });
  }

}
